export const signedUrlExtractor = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const url = urlParams.get('url') || '';
  const query = urlParams.get('search') || '';
  const print = urlParams.get('print') || 'false';
  const page = urlParams.get('page') || '1';
  return { url, query, print, page };
}
